import commonFun from "../lib/commonFun";

export const doLogin = (formData) => {
  return commonFun.postProxy('admin/system/login/doLogin',formData)
}

export const loginOut = () => {

}
